import { Link } from '@tanstack/react-router'
import { LegalLayout } from '~/components/marketing/legal-layout'
import '~/styles/marketing.css'

export const PrivacyPage = () => (
  <LegalLayout title="Política de Privacidade" updatedAt="2 de dezembro de 2025">
    <h2>1. Introdução</h2>
    <p>
      O Planno (&ldquo;nós&rdquo;, &ldquo;nosso&rdquo; ou &ldquo;Plataforma&rdquo;) tem o
      compromisso de proteger a privacidade e os dados pessoais de seus usuários. Esta Política de
      Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações quando
      você utiliza nossa plataforma de gestão de obras.
    </p>
    <p>
      Esta política se aplica a todos os usuários da Plataforma, incluindo visitantes do site,
      usuários cadastrados e membros de equipes de projetos. Ao utilizar nossos serviços, você
      concorda com as práticas descritas neste documento.
    </p>
    <p>
      Recomendamos a leitura atenta desta Política em conjunto com nossos{' '}
      <Link to="/termos-de-uso">Termos de Uso</Link>.
    </p>

    <h2>2. Dados que Coletamos</h2>
    <h3>2.1 Dados de Cadastro</h3>
    <p>Quando você cria uma conta no Planno, coletamos:</p>
    <ul>
      <li>Nome completo</li>
      <li>Endereço de e-mail</li>
      <li>Número de telefone</li>
      <li>Nome da empresa ou escritório</li>
    </ul>
    <h3>2.2 Dados de Uso</h3>
    <p>Coletamos automaticamente informações sobre como você interage com a Plataforma:</p>
    <ul>
      <li>Endereço IP e localização aproximada</li>
      <li>Tipo de dispositivo e navegador</li>
      <li>Sistema operacional</li>
      <li>Páginas visitadas e funcionalidades utilizadas</li>
      <li>Data e hora de acesso</li>
      <li>Tempo de permanência na Plataforma</li>
    </ul>
    <h3>2.3 Conteúdo do Usuário</h3>
    <p>Para fornecer nossos serviços, armazenamos o conteúdo que você envia à Plataforma:</p>
    <ul>
      <li>Arquivos de projeto em diversos formatos</li>
      <li>Fotos de visitas de obra</li>
      <li>Anotações e comentários</li>
      <li>Informações de cronogramas e tarefas</li>
      <li>Dados de membros da equipe do projeto</li>
    </ul>

    <h2>3. Como Coletamos seus Dados</h2>
    <h3>3.1 Informações Fornecidas por Você</h3>
    <p>
      Coletamos dados quando você preenche formulários de cadastro, atualiza seu perfil, envia
      arquivos, cria projetos ou interage com funcionalidades da Plataforma.
    </p>
    <h3>3.2 Coleta Automática</h3>
    <p>
      Utilizamos tecnologias como cookies e ferramentas de análise para coletar automaticamente
      dados de uso quando você acessa nossa Plataforma.
    </p>
    <h3>3.3 Terceiros</h3>
    <p>
      Podemos receber informações de serviços de autenticação (como login social) caso você opte por
      utilizá-los.
    </p>

    <h2>4. Finalidade do Tratamento</h2>
    <p>Utilizamos seus dados para:</p>
    <h3>4.1 Prestação do Serviço</h3>
    <ul>
      <li>Criar e gerenciar sua conta</li>
      <li>Fornecer as funcionalidades da Plataforma</li>
      <li>Sincronizar dados entre dispositivos</li>
      <li>Permitir colaboração entre membros da equipe</li>
    </ul>
    <h3>4.2 Comunicação</h3>
    <ul>
      <li>Enviar notificações sobre sua conta e projetos</li>
      <li>Responder a solicitações de suporte</li>
      <li>Informar sobre atualizações importantes</li>
    </ul>
    <h3>4.3 Melhorias e Análises</h3>
    <ul>
      <li>Analisar uso da Plataforma (dados anonimizados)</li>
      <li>Identificar e corrigir problemas técnicos</li>
      <li>Desenvolver novas funcionalidades</li>
    </ul>
    <h3>4.4 Segurança</h3>
    <ul>
      <li>Detectar e prevenir fraudes</li>
      <li>Proteger contra acessos não autorizados</li>
      <li>Cumprir obrigações legais</li>
    </ul>

    <h2>5. Base Legal para Tratamento (LGPD)</h2>
    <p>
      O tratamento de seus dados pessoais é realizado com fundamento nas seguintes bases legais
      previstas na Lei Geral de Proteção de Dados (Lei nº 13.709/2018):
    </p>
    <ul>
      <li>
        <strong>Execução de contrato:</strong> para fornecer os serviços contratados e gerenciar sua
        conta.
      </li>
      <li>
        <strong>Consentimento:</strong> para envio de comunicações de marketing e uso de cookies não
        essenciais.
      </li>
      <li>
        <strong>Legítimo interesse:</strong> para melhorias na Plataforma, análises de segurança e
        prevenção de fraudes.
      </li>
      <li>
        <strong>Cumprimento de obrigação legal:</strong> para atender exigências legais e
        regulatórias.
      </li>
    </ul>

    <h2>6. Cookies</h2>
    <p>Utilizamos cookies e tecnologias similares para melhorar sua experiência na Plataforma.</p>
    <h3>6.1 Cookies Essenciais</h3>
    <p>
      Necessários para o funcionamento básico da Plataforma. Incluem cookies de sessão, autenticação
      e preferências de segurança. Não podem ser desativados.
    </p>
    <h3>6.2 Cookies de Analytics</h3>
    <p>
      Utilizados para entender como os usuários interagem com a Plataforma: quais páginas são
      acessadas, quais recursos são utilizados e onde surgem dificuldades. Esses dados nos ajudam a
      corrigir problemas e melhorar nossos serviços.
    </p>
    <h3>6.3 Gerenciamento de Cookies</h3>
    <p>
      Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.
      Note que desativar certos cookies pode afetar a funcionalidade da Plataforma.
    </p>

    <h2>7. Compartilhamento de Dados</h2>
    <h3>7.1 Não Vendemos seus Dados</h3>
    <p>
      O Planno não vende, aluga ou comercializa seus dados pessoais com terceiros para fins de
      marketing.
    </p>
    <h3>7.2 Processadores e Parceiros</h3>
    <p>
      Podemos compartilhar dados com prestadores de serviços que nos auxiliam na operação da
      Plataforma:
    </p>
    <ul>
      <li>Provedores de infraestrutura e hospedagem</li>
      <li>Serviços de processamento de pagamentos</li>
      <li>Ferramentas de análise de uso e monitoramento de erros (como PostHog e Sentry)</li>
      <li>Serviços de comunicação (e-mail, notificações)</li>
    </ul>
    <p>
      Esses parceiros são contratualmente obrigados a proteger seus dados e utilizá-los apenas para
      os fins especificados.
    </p>
    <h3>7.3 Obrigações Legais</h3>
    <p>
      Podemos divulgar dados quando exigido por lei, ordem judicial ou autoridade competente, ou
      para proteger nossos direitos, propriedade ou segurança.
    </p>

    <h2>8. Armazenamento e Segurança</h2>
    <h3>8.1 Medidas de Proteção</h3>
    <p>Implementamos medidas técnicas e organizacionais para proteger seus dados:</p>
    <ul>
      <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
      <li>Criptografia de dados em repouso</li>
      <li>Controles de acesso baseados em função</li>
      <li>Monitoramento contínuo de segurança</li>
      <li>Backups regulares</li>
    </ul>
    <h3>8.2 Período de Retenção</h3>
    <p>
      Mantemos seus dados enquanto sua conta estiver ativa. Após o cancelamento da conta, seus dados
      são retidos por 30 (trinta) dias para possibilitar eventual reativação. Após esse período, os
      dados são permanentemente excluídos.
    </p>
    <p>
      Alguns dados podem ser retidos por períodos mais longos quando necessário para cumprimento de
      obrigações legais ou resolução de disputas.
    </p>

    <h2>9. Seus Direitos</h2>
    <p>
      A Lei Geral de Proteção de Dados garante a você os seguintes direitos em relação aos seus
      dados pessoais:
    </p>
    <ul>
      <li>
        <strong>Confirmação e acesso:</strong> saber se tratamos seus dados e acessar suas
        informações.
      </li>
      <li>
        <strong>Correção:</strong> solicitar a correção de dados incompletos, inexatos ou
        desatualizados.
      </li>
      <li>
        <strong>Anonimização, bloqueio ou eliminação:</strong> solicitar o tratamento de dados
        desnecessários ou excessivos.
      </li>
      <li>
        <strong>Portabilidade:</strong> receber seus dados em formato estruturado para
        transferência.
      </li>
      <li>
        <strong>Eliminação:</strong> solicitar a exclusão de dados tratados com base no
        consentimento.
      </li>
      <li>
        <strong>Informação:</strong> saber com quem seus dados são compartilhados.
      </li>
      <li>
        <strong>Revogação do consentimento:</strong> retirar seu consentimento a qualquer momento.
      </li>
    </ul>
    <h3>9.1 Como Exercer seus Direitos</h3>
    <p>
      Para exercer qualquer um desses direitos, entre em contato conosco através do e-mail{' '}
      <a href="mailto:contato@planno.app">contato@planno.app</a>. Responderemos sua solicitação no
      prazo legal de 15 (quinze) dias.
    </p>

    <h2>10. Transferência Internacional de Dados</h2>
    <p>
      Para fornecer nossos serviços, seus dados podem ser transferidos e armazenados em servidores
      localizados fora do Brasil. Quando isso ocorrer, garantimos que a transferência seja realizada
      em conformidade com a LGPD, através de:
    </p>
    <ul>
      <li>Cláusulas contratuais padrão aprovadas</li>
      <li>Países com nível adequado de proteção de dados</li>
      <li>Outras salvaguardas previstas em lei</li>
    </ul>

    <h2>11. Menores de Idade</h2>
    <p>
      A Plataforma Planno é destinada exclusivamente a usuários maiores de 18 (dezoito) anos. Não
      coletamos intencionalmente dados de menores de idade. Se tomarmos conhecimento de que
      coletamos dados de um menor, tomaremos medidas para excluir essas informações o mais rápido
      possível.
    </p>

    <h2>12. Alterações nesta Política</h2>
    <p>
      Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças em nossas
      práticas ou por exigências legais. Quando fizermos alterações significativas, notificaremos
      você por e-mail ou através de aviso na Plataforma.
    </p>
    <p>
      Recomendamos revisar esta página periodicamente. A data da última atualização está indicada no
      início deste documento.
    </p>

    <h2>13. Contato</h2>
    <p>
      Se você tiver dúvidas, preocupações ou solicitações relacionadas a esta Política de
      Privacidade ou ao tratamento de seus dados pessoais, entre em contato conosco:
    </p>
    <p>
      <strong>Planno</strong>
      <br />
      E-mail: <a href="mailto:contato@planno.app">contato@planno.app</a>
    </p>
    <p>
      Você também tem o direito de registrar reclamação junto à Autoridade Nacional de Proteção de
      Dados (ANPD) caso entenda que o tratamento de seus dados não está em conformidade com a
      legislação.
    </p>
  </LegalLayout>
)
